import React from 'react';
import { useTranslation } from 'next-i18next';
import { useAnalytics } from '@context/analytics/analytics.context';
import Button from '@components/atoms/button/button';
import { accountSettingsEditEventPayload } from '@tracking/account-settings/account-settings-tracking';
import styles from './account-settings-section-header.module.scss';

type AccountSettingsSectionHeaderProps = {
  title: string;
  onEditClick?: () => void;
  trackingProperty?: string;
  isEditing?: boolean;
  isEditable?: boolean;
  'data-cy'?: string;
};

const AccountSettingsSectionHeader: React.FC<AccountSettingsSectionHeaderProps> = ({
  title,
  onEditClick,
  trackingProperty,
  isEditing = false,
  isEditable = true,
  'data-cy': dataCy,
}) => {
  const { t } = useTranslation('account-settings');
  const { sendEvent } = useAnalytics();

  const handleEditClick = () => {
    if (!isEditing && trackingProperty) {
      sendEvent({ type: 'event', payload: { ...accountSettingsEditEventPayload, property: trackingProperty } });
    }
    onEditClick?.();
  };

  return (
    <div className={styles.accountSettingsSectionHeader}>
      <h2 className={styles.accountSettingsSectionHeader__title}>{title}</h2>
      {isEditable && (
        <Button
          type="button"
          size="medium"
          onClick={handleEditClick}
          iconLeft={isEditing ? 'close-default' : 'edit-default'}
          aria-label={isEditing ? t('ACCOUNT_SETTINGS.CLOSE') : t('ACCOUNT_SETTINGS.EDIT')}
          data-cy={dataCy}
          className={styles.accountSettingsSectionHeader__editButton}
        >
          {isEditing ? t('ACCOUNT_SETTINGS.CLOSE') : t('ACCOUNT_SETTINGS.EDIT')}
        </Button>
      )}
    </div>
  );
};

export default AccountSettingsSectionHeader;
